import {Component, forwardRef, Input} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR, ValidationErrors,
  Validator
} from '@angular/forms';
import * as moment from "moment-mini-ts";

@Component({
  selector: 'app-date-input',
  styleUrls: ['./date-input.component.sass'],
  templateUrl: './date-input.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateInputComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DateInputComponent),
      multi: true,
    },
  ]
})
export class DateInputComponent implements ControlValueAccessor, Validator {
  @Input() label = '';

  public val = ''
  public disabled = false

  set value(val) {
    if (val !== undefined && this.val !== val) {
      this.val = val
      this._onChange(this.toDate(val))
    }
  }

  get value() {
    return this.val
  }

  constructor() {
  }

  private _onChange = (value: Date | null) => undefined;

  registerOnChange(fn: any): void {
    this._onChange = fn
  }

  public _onTouched = () => undefined;

  registerOnTouched(fn: any): void {
    this._onTouched = fn
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
  }

  writeValue(value: Date): void {
    this.value = this.toString(value)
  }

  isValidDate(d: string | number | null) {
    const date = moment(d, "DD.MM.YYYY")
    return date.isValid()
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return control.value && this.val.length === 10 ? null :
      {invalidDate: true};
  }


  private toString(date: Date) {
    return moment(date).format('DD.MM.YYYY').toString()
  }

  private toDate(date: string) {
    return date.length > 0 ? moment(date, 'DD.MM.YYYY').toDate() : undefined
  }
}
